import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { withTranslation } from 'react-i18next';

import React, { Component } from 'react'

import IconSVG from "../../utilities/FrontFunctions/IconSVG"
import { GetFriendlyUrl } from "../../utilities/FrontFunctions/AoxFrontFunctions";
import { Image } from "@sitecore-jss/sitecore-jss-react";

import '../../assets/css/0010_sections/0430_section_aside_content_formation.css'
import '../../assets/css/0020_objects/0930_obj_outils_download_comptoir_dermato.css'

class ObjOutilsDownloadComptoirDermato extends Component {
	render() {
        const { datasOutils } = this.props;

		return (<>{datasOutils && <>
			<div className="obj_outils_download_comptoir_dermato">
				<div className="ctn_title">
			 		<h3 className="t_title"><strong>Nos outils</strong></h3>
			 		<p className="t_desc">à télécharger</p>
			 	</div>
				
				<ul className="obj_list_outils_download">
					{ datasOutils.map((OutilsDownloadItem, index) => (<div key={index} >{
                        GetFriendlyUrl(OutilsDownloadItem.pageLink) && 
                        <li className="item">
                            <a href={GetFriendlyUrl(OutilsDownloadItem.pageLink)}>
                                <div className="v_icon">
                                    <Image field={OutilsDownloadItem.pageImage.jss}></Image>
                                </div>

                                <div className="ctn_text">
                                    <p className="t_title"><strong>{OutilsDownloadItem.pageTitle.jss.value}</strong></p>
                                    <p className="t_desc">{OutilsDownloadItem.pageSubtitle.jss.value}</p>
                                </div>

                                <button className="btn_download">
                                    <IconSVG icon="download_file" />
                                </button>
                            </a>
                        </li>
                    }</div>))}
				</ul>
				
			</div>
        </>}</>)
	}

}

export default withTranslation()(withSitecoreContext()(ObjOutilsDownloadComptoirDermato));